import { Combobox as ComboboxPrimitive } from '@base-ui/react/combobox';

import ChevronDownIcon from '@/assets/svg/chevron-down.svg?react';
import { Spinner } from '@/components/loaders';
import { cn } from '@/lib/utils';

import { pickerTriggerIconSizeClasses } from '../pickerPrimitiveStyles';
import { useComboboxContext } from './ComboboxContext';

export type ComboboxIconTriggerProps = ComboboxPrimitive.Trigger.Props;

const ComboboxIconTrigger = ({ className, children, ...props }: ComboboxIconTriggerProps) => {
  const { size, isLoading, disabled = false } = useComboboxContext();

  return (
    <ComboboxPrimitive.Trigger
      className={cn(
        'flex size-full items-center justify-center rounded-none border-0 bg-transparent p-0 outline-none',
        'aria-expanded:[&_svg]:rotate-180',
        'disabled:cursor-not-allowed disabled:[&_svg]:text-gray-500',
        '[&_svg]:pointer-events-none [&_svg]:shrink-0',
        pickerTriggerIconSizeClasses[size],
        className,
      )}
      data-slot="combobox-icon-trigger"
      disabled={disabled}
      {...props}
    >
      {children}
      {isLoading ? (
        <Spinner className="pointer-events-none" />
      ) : (
        <ChevronDownIcon className="pointer-events-none text-gray-900 transition-transform duration-100" />
      )}
    </ComboboxPrimitive.Trigger>
  );
};

export default ComboboxIconTrigger;
